<div class="content">
  <div class="description subtitle">
    {{ 'AUTOMATIONS.EDITOR.TASKS.CREATE_PROJECT_IN_TASK_MANAGER.CREATE_PROJECT_DESCRIPTION' | translate }}
  </div>
  <form [formGroup]="form">
    <automata-project-template-selector
      [form]="form"
      [templateId]="initialTemplateId"
      [title]="initialTitle"
      (savingEnabled)="enableSaving($event)"
    ></automata-project-template-selector>
  </form>
</div>
